export default "https://assets.pclncdn.com/web/next-landing/62eec7c/_next/static/images/san-diego-83e75d60d53011bc38967063efd3ed6b.webp";